<template>
  <div id="app">
    <router-view v-if="refresh"/>
  </div>
</template>

<script setup>
import { ref, onMounted, nextTick } from 'vue';

const refresh = ref(true);

onMounted(() => {
  // 强制刷新路由视图
  refresh.value = false;
  nextTick(() => {
    refresh.value = true;
  });
});

// 解决ERROR ResizeObserver loop completed with undelivered notifications.
const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    let context = this;
    let args = arguments;
    clearTimeout(timer);
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = debounce(callback, 16);
    super(callback);
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  background-image: url("/src/assets/index-bg1.jpg");
  background-size: cover;
  background-position: center;
  height: 100vh;

}
/* 搜索框样式 */
.search-container {
  display: flex;
  align-items: center;
  margin-top: 8px;
}

.search-item {
  margin-left: 16px; /* 每个元素左侧间距 */
  border: 1px solid #dcdee1;
  width: 200px;
  border-radius: 4px
}
.search-select {
  border: 1px solid #dcdee1;
  width: 180px;
  margin-left: 16px;
  border-radius: 4px
}
.search-button{
  margin-left: 16px;
  border-radius: 4px
}
.search-picke{
  border: 1px solid #dcdee1;
  width: 254px;
  border-radius: 4px
}
.search-data-picke{
  width: 420px;
  border-radius: 4px;
  margin-left: 16px;
}
.search-item:first-child {
  margin-left: 0; /* 第一个元素不需要左边距 */
}
.search-input {
  width: 360px;
}
.search-input :deep(.el-input__wrapper) {
  background: #fff;
  border-radius: 4px;
}
/* 搜索框样式 */

/* 添加样式 */
.action-group {
    display: flex;
    gap: 12px;
    margin-top: 16px;
    padding: 4px 0;
  }

.mall-management-container {
  padding: 16px;
  background-color: #f3f5f9;
  border-radius:8px;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
  height: 32px;
}

.page-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
}

.header-actions {
  display: flex;
  gap: 12px;
  height: 32px;
}

.search-card {
  background: #fff;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.table-card {
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

:deep(.arco-table-th) {
  background-color: #fafafa;
  font-weight: 500;
}

:deep(.arco-table-cell) {
  padding: 12px 16px;
}
/* 添加图片样式 */
.image-picker {
  width: 100px;
  height: 100px;
  border: 1px dashed var(--color-border-3);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.2s;
}

.image-picker:hover {
  border-color: var(--color-primary);
}

.image-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: var(--color-text-3);
}

.image-placeholder .arco-icon {
  font-size: 24px;
  margin-bottom: 8px;
}

.placeholder-text {
  font-size: 14px;
}

.image-preview {
  width: 100%;
  height: 100%;
  position: relative;
}

.image-preview img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.replace-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
}

.replace-overlay .arco-icon {
  font-size: 20px;
  margin-bottom: 4px;
}

.image-preview:hover .replace-overlay {
  opacity: 1;
}

.arco-card.arco-card-size-medium .arco-card-body {
  padding: 16px !important; /* 提高特异性层级 */
}

/* 修正选择器层级 */
.image-picker .image-preview img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.form-section {
  margin-bottom: 20px;
}
</style>
